define('home/models/UnreadCounter',[
    'backbone',
    'core/api',
    'core/config',
], function (
    Backbone,
    api,
    coreConfig
) {
    'use strict';

    var parent = Backbone.Model;
    var parentProto = parent.prototype;


    /**
     * UnreadCounter
     * convenient interface to getUnreadCount endpoint
     */
    return parent.extend({
        initialize: function (_attributes, options) {
            options = options || {};
            this.uniqueTogether = {
                type: options.type,
                index: options.index,
                target: options.target,
            };
            this.prepareFetchOptions = options.prepareFetchOptions;
        },

        defaults: {
            // Deliberately set to undefined and not 0 to be able
            // to use this.has('numUnread') as a way to check if value
            // has ever been set.
            numUnread: undefined,
        },

        url: api.getURL('timelines/getUnreadCount'),

        fetch: function (options) {
            if (this.prepareFetchOptions)
                options = this.prepareFetchOptions(options);

            options.data.routingVersion = coreConfig.feedApiVersion;

            return parentProto.fetch.call(this, options);
        },

        parse: function (response, options) {
            // Do not set numUnread if this response is only intended to initialize
            // the numUnread value but numUnread has already been set or cleared.
            //
            // This is to protect from a possible race condition between
            // the fetch for notifications and the fetch for unread count.
            // If the notifications fetch returns before the unread count,
            // then we can end up in a situation where the notifications
            // response causes the notifications bubble to be cleared, but then
            // the unread count response comes in and causes the notifications
            // bubble to be populated with a possibly outdated numUnread value.
            if (options.initializeOnly && this.has('numUnread'))
                return;

            return { numUnread: response.response };
        },
    });
});

